import { AiHistoryModel, ICTask } from './Interfaces';

export enum StorageTags {
  taskTray = 'taskTray',
  aiHistory = 'aiHistory',
}

export class LocalStorageHelper {
  //constructor() {}

  getTaskTray(): ICTask[] {
    const trayList = localStorage.getItem(StorageTags.taskTray);
    return trayList !== null ? (JSON.parse(trayList) as ICTask[]) : [];
  }

  setTaskTray(list: ICTask[]): void {
    localStorage.setItem(StorageTags.taskTray, JSON.stringify(list));
  }

  getAiHistoryTray(): AiHistoryModel[] {
    const historyList = localStorage.getItem(StorageTags.aiHistory);
    return historyList !== null
      ? (JSON.parse(historyList) as AiHistoryModel[])
      : [];
  }

  setAiHistoryTray(aiHistory: AiHistoryModel[]): void {
    localStorage.setItem(StorageTags.aiHistory, JSON.stringify(aiHistory));
  }
}
